import { Typography } from '@frontend/design_system'
import styles from './styles.module.scss'
import { ReactNode } from 'react'

interface IBlockProps {
  title: string
  children: ReactNode
  description?: string
}

export const Block = ({ title, children, description }: IBlockProps) => (
  <div className={styles.block}>
    <div className={styles.header}>
      <Typography name="subtitleWBold" className={styles.title} Tag="h3">
        {title}
      </Typography>
      {description && (
        <Typography color="grey500" name="body2WMedium">
          {description}
        </Typography>
      )}
    </div>
    {children}
  </div>
)
